export const menuDynamic = [
  {
    id: 1,
    text: 'Painel Geral',
    clickable: true,
    componentName: 'PainelGeral',
  },
  {
    id: 2,
    text: 'Top Supervisores',
    clickable: true,
    componentName: 'TopSupervisores',
  },
  {
    id: 3,
    text: 'Consultores',
    icon: 'ArrowUp',
    clickable: true,
    unique: 'up',
    componentName: 'BestConsultores',
  },
  {
    id: 4,
    text: 'Consultores',
    icon: 'ArrowDown',
    clickable: true,
    unique: 'down',
    componentName: 'BadConsultores',
  },
  {
    id: 5,
    text: 'Top Consultores Iniciantes',
    clickable: true,
    componentName: 'TopInitialConsultores',
  },
  { id: 6, text: 'Modo Apresentação', icon: 'Maximize', clickable: true },
  {
    id: 7,
    text: 'Configuração',
    clickable: true,
    icon: 'Settings',
    componentName: 'modalDivisoes',
  },
];
